<template>
    <div class="wrap">
        <conversation-table ref="table" :url="indexUrl">
            <template v-slot:buttons>
                <button class="btn btn-purple" v-if="canCreate" @click="addConversation">
                    <i class="far fa-file"></i>
                </button>
            </template>
        </conversation-table>
        <dialog-form-wrapper></dialog-form-wrapper>
        <dialog-export-wrapper></dialog-export-wrapper>
    </div>
</template>

<script>
  import ConversationTable from '../../components/conversations/table';
  import DialogFormWrapper from './dialog-form-wrapper';
  import DialogExportWrapper from './dialog-export-wrapper';

  export default {
    components: {
      ConversationTable,
      DialogFormWrapper,
      DialogExportWrapper,
    },

    props: {
      indexUrl: null,
      createUrl: null,
      canCreate: {
        type: Boolean,
        default: false
      },
    },

    methods: {
      /**
       * @return {undefined}
       */
      refresh() {
        this.$refs.table.refresh();
      },

      /**
       * @event show-add-conversation-dialog
       */
      addConversation() {
        eventBus.$emit('show-add-conversation-dialog', this.createUrl);
      },


    },

    created() {
      eventBus.$on('refresh-conversations-table', this.refresh);
    },

    beforeDestroy() {
      eventBus.$off('refresh-conversations-table', this.refresh);
    }
  }
</script>
